export type AppRole = "viewer" | "specialist" | "admin";
export interface UserProfile { id: string; displayName: string; role: AppRole; organization: string | null; }
export const roleWeight: Record<AppRole, number> = { viewer: 1, specialist: 2, admin: 3 };
